<script setup lang="ts">
import { store } from '@/store';

const props = defineProps({
  userInputting: Boolean
});

const emit = defineEmits(['onSelectPrompt']);

document.addEventListener('keydown', function (event) {
  const key = Number(event.key);
  if (
    !props.userInputting &&
    event.key != ' ' &&
    !isNaN(key) &&
    key <= store.getExamplePrompts().length
  ) {
    selectPrompt(key - 1);
  }
});

function selectPrompt(index: number) {
  const prompt = store.getExamplePrompts()[index];

  window.setTimeout(() => emit('onSelectPrompt', prompt), 50);
}
</script>

<template>
  <ul>
    <li v-for="(prompt, i) of store.getExamplePrompts()" @click="selectPrompt(i)">
      <span class="prompt-number">
        {{ i + 1 }}
      </span>
      <p>
        {{ prompt[store.lang] }}
      </p>
    </li>
    <span class="close-button" @click="store.setExamplePromptsVisible(false)">×</span>
  </ul>
</template>

<style scoped>
ul {
  list-style-type: none;
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 4em;
  margin-right: 2em;
  padding: 0.5em;
}
ul:hover {
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  border-radius: 3px;
  background-color: rgba(161, 161, 161, 0.1);
}
.close-button {
  color: white;
  position: fixed;
  right: 0.5em;
  text-align: center;
  line-height: 1.2em;
  border-radius: 0.6em;
  height: 1.2em;
  width: 1.2em;
  cursor: pointer;
}
.close-button:hover {
  background-color: white;
  color: lightgray;
}
li {
  display: inline-block;
  box-shadow: 0px 0px 5px lightgray;
  cursor: pointer;
  background-color: #eff1f3;
  border-radius: 0.2rem;
  padding: 0.4rem;
  font-size: 0.5em;
  width: 30%;
  margin: 0 1em;
  color: #4b647d;
}
li:hover {
  background-color: #e0e4e8;
}
.prompt-number {
  font-size: 2em;
  color: #c1c9d1;
  display: block;
  position: relative;
  top: -1rem;
  right: 1rem;
  height: 1.5rem;
  width: 1.5rem;
  text-align: center;
  border-radius: 50%;
  background-color: #e0e4e8;
}
p {
  margin-bottom: 0;
  margin-top: -1.5rem;
  position: relative;
  font-size: 1.7em;
  z-index: 10;
}
</style>
